import emailValidator from '../../utils/Validate';

export const validateNotificationPhoneHookForm = (values: any): any => {
  const errors: any = {};
  if (
    !values.notificationPhone ||
    !values.notificationPhone.replace(/\s/g, '').length ||
    !values.notificationPhone.replace(/[^0-9]+/g, '')
  ) {
    errors.notificationPhone = 'DUE_INVOICES.ERRORS.INVALID_NOTIFICATION_PHONE';
  }
  return errors;
};

export const validateEmailHookForm = (values: any): any => {
  const errors: any = {};
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.email = 'VALIDATORS.EMAIL_REQ';
  } else if (!emailValidator(String(values.email).toLowerCase())) {
    errors.email = 'VALIDATORS.INVALID_EMAIL';
  }
  return errors;
};
